<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item label="封面图片(320*320)" prop="mediaUrl">
        <div class="a-input">
          <simple-uploader-s3 v-model="form.data.mediaUrl"/>
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <div>是否展示:
          <a-switch style="margin-left: 20px" v-model="showSwitch" @change="onShowChange"/>
        </div>
      </a-form-model-item>
      <a-form-model-item label="商品名称" prop="name">
        <a-input v-model="form.data.name" auto-focus/>
      </a-form-model-item>
      <a-form-model-item label="IG链接" prop="permalink">
        <a-input :disabled="true" v-model="form.data.permalink"/>
      </a-form-model-item>
      <a-form-model-item label="IG配文" prop="caption">
        <a-input :disabled="true" v-model="form.data.caption"/>
      </a-form-model-item>
      <a-form-model-item label="IG类型" prop="mediaType">
        <a-input :disabled="true" v-model="form.data.mediaType"/>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" v-if="!instagramId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="instagramId" @click="onUpdate">更新</a-button>
        <a-button style="margin-left: 20px" @click="onCancel">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {
  _queryGoodsInstagram,
  _addGoodsInstagram,
  _updateGoodsInstagram,
} from '@/api/websiteGoodsInstagramApi';
import SimpleUploaderS3 from '@/components/SimpleUploaderS3.vue';

async function getInstagram() {
  const result = await _queryGoodsInstagram(this.instagramId);
  if (result) {
    this.form.data.mediaUrl = result.mediaUrl;
    this.form.data.name = result.name;
    this.form.data.permalink = result.permalink;
    this.form.data.mediaType = result.mediaType;
    this.form.data.caption = result.caption;
    this.form.data.isShow = result.isShow;
    this.showSwitch = result.isShow === 'YES';
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsInstagram({
        name: this.form.data.name,
        mediaUrl: this.form.data.mediaUrl,
        permalink: this.form.data.permalink,
        mediaType: this.form.data.mediaType,
        caption: this.form.data.caption,
        isShow: this.form.data.isShow,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsInstagram(this.instagramId, {
        name: this.form.data.name,
        permalink: this.form.data.permalink,
        mediaType: this.form.data.mediaType,
        mediaUrl: this.form.data.mediaUrl,
        caption: this.form.data.caption,
        isShow: this.form.data.isShow,
      });
      if (result) {
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        if (this.onSubmitHandler) {
          this.onSubmitHandler();
        }
      }
    }
  });
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function onShowChange() {
  if (this.showSwitch === true) {
    this.form.data.isShow = 'YES'
  } else {
    this.form.data.isShow = 'NO'
  }
}

export default {
  name: 'InstagramEdit',
  components: {
    SimpleUploaderS3,
  },
  props: {
    instagramId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    instagramId() {
      if (this.instagramId) {
        this.getInstagram();
      }
    },
  },
  methods: {
    onAdd,
    onCancel,
    getInstagram,
    reviewVideo,
    onUpdate,
    onShowChange,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      showSwitch: false,
      form: {
        data: {
          name: '',
          subName: '',
          mediaUrl: '',
          permalink: '',
          mediaType: '',
          caption: '',
          isShow: '',
        },
        rules: {
          mediaUrl: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.instagramId) {
      await this.getInstagram();
    }
  },
};
</script>
